<template>
    <div>
        <small>{{ label }}</small>
        <div class="input_container">
            <div v-if="multiple" class="input-group input-group--text-field primary--text" style="display:block;">
                <label v-if="placeholder && !select_value" style="pointer-events:none;">{{ placeholder }}</label>
                <select
                        v-model="select_value"
                        multiple
                        :style="style"
                        :id="id"
                        :name="name"
                        class="input-group input-group--single-line input-group--solo native_select">
                    <option v-for="(item, index) in items" :key="index" :value="item[itemValue]" :selected="(value) ? value.includes(item[itemValue]): ''">
                        {{ item[itemText]}}
                    </option>
                </select>
                <div class="input-group__details"><div class="input-group__messages input-group__hint">Usar ctrl + click para seleccionar múltiples opciones</div></div>
            </div>
            <div v-else class="input-group input-group--text-field primary--text">
                <div class="input-group input-group--text-field primary--text">
                    <select v-model="select_value"
                            :style="style"
                            :id="id"
                            :name="name"
                            class="input-group input-group--single-line input-group--solo native_select">
                        <option v-for="(item, index) in items" :key="index" :value="item[itemValue]" :selected="value == item[itemValue]">
                            {{ item[itemText]}}
                        </option>
                    </select>
                    <div v-if="hint" class="input-group__details"><div class="input-group__messages input-group__hint">{{ hint }}</div></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['id', 'name', 'value', 'hint', 'label', 'placeholder', 'multiple', 'items', 'itemText', 'itemValue', 'style'],
        computed: {
            select_value: {
                get() {
                    return this.value
                },
                set(v) {
                    this.$emit('input', v)
                }
            }
        },
        methods: {
            onChange() {
                this.$emit('input', this.value)
            }
        },
        mounted() {
            // eslint-disable-next-line
            if (this.value)
                this.$emit('input', this.value)

            if (!this.style)
                this.style = 'width:auto'
        }
    }
</script>
<style scoped>
    .input_container {
        position: relative
    }

        .input_container label {
            position: absolute;
            top: 0;
            left: 0;
            position: absolute;
            color: rgba(0, 0, 0, 0.55);
            height: 100%;
            width: 100%;
            display: flex;
            z-index: 1;
            align-items: center;
            padding: 8px 16px;
        }

    small {
        color: rgba(0,0,0,.54);
    }

    .input-group.native_select {
        padding: 8px 16px;
        background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right 0.75rem center;
        background-size: 8px 10px;
        font-size: 1rem;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/utils/NativeSelect.vue